<template>
  <div class="content">
    <div class="wrapper">
      <div class="header">
        <img src="@assets/img/share/img_slogn.png" alt="" />
      </div>
      <div class="body">
        <div class="body-bag">
          <p>好友正在偷偷学</p>
          <p>快去APP评论吧～</p>
          <div class="body-bag-photo">
            <img :src="coverImgUrl" alt="" />
          </div>
          <div class="download" @click="shareHandle">免费领取体验课程</div>
        </div>
        <div class="left-boy"></div>
        <div class="right-girl"></div>
      </div>
    </div>
    <div class="footer">
      <img src="@assets/img/share/img_logo.png" alt />
    </div>
  </div>
</template>

<script>
export default {
  name: "share",
  data() {
    return {
      userName: "睿识课",
      coverImgUrl:
        "",
      title: "",
    };
  },
  mounted() {
    this.getUrlParams();
  },
  components: {},
  methods: {
    getUrlParams() {
      this.coverImgUrl = 'https://rskjy.oss-cn-beijing.aliyuncs.com/default/' + this.$route.query.thumbImageUrl
      this.title = this.$route.query.title;
    },
    shareHandle() {
      let url = "https://bxgxmh.jgmlink.cn/AA8a"; //ios
      window.location.href = url;
      // this.loadURL(url);
    },
    // 给原生传递数据
    loadURL(url) {
      var iFrame;
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        //安卓终端使用iframe
        iFrame = document.createElement("iframe");
        iFrame.setAttribute("src", "https://bxgxmh.jgmlink.cn/AA8a");
        iFrame.setAttribute("style", "display:none;");
        iFrame.setAttribute("height", "0px");
        iFrame.setAttribute("width", "0px");
        iFrame.setAttribute("frameborder", "0");
        document.body.appendChild(iFrame);
        // 发起请求后这个 iFrame 就没用了，所以把它从 dom 上移除掉
        iFrame.parentNode.removeChild(iFrame);
        iFrame = null;
      } else if (isiOS) {
        //iOS终端直接页面跳转
        window.location.href = url;
        // 如果用户没有安装淘宝APP，则提示用户去安装淘宝
        // setTimeout(() => {
        //   alert("请去应用市场下载App"); // 这里可以自行写一个延时关闭的弹窗，也可以跳转至app下载地址，我这里就偷懒了
        // }, 2000);
      } else {
        window.location.href = url;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.content {
  height: 608px;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: url(~@assets/img/share/ing_bg.png) no-repeat center;
  background-size: 100%;
  position: relative;
  .wrapper {
    width: 100%;
    // height: 984px;
    // padding-top: 128px;
    .header {
      height: 94px;
      width: 100%;
      display: flex;
      justify-content: center;
      img {
        width: 293px;
        height: 52px;
        margin-top: 50px;
      }
    }
    .body {
      width: 100%;
      display: flex;
      justify-content: center;
      position: relative;
      &-bag {
        height: 329px;
        width: 282px;
        margin-top: 27px;
        background: url(~@assets/img/share/img_bag.png) no-repeat center;
        background-size: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        p {
          text-align: center;
          &:nth-of-type(1) {
            height: 27px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #945e0e;
            line-height: 22px;
            margin-top: 32px;
            padding-right: 10px;
          }
          &:nth-of-type(2) {
            height: 23px;
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #f54716;
            line-height: 22px;
            margin-top: 5px;
          }
        }
        &-photo {
          height: 120px;
          width: 215px;
          margin: 0 auto;
          margin-top: 25px;
          border: 1px solid #f0dba9;
          box-shadow: 0px 4px 8px 0px #ba311f;
          img {
            border: 6px solid #feffec;
            height: 108px;
            width: 203px;
          }
        }
        .download {
          width: 195px;
          height: 36px;
          background: linear-gradient(360deg, #ffd06e 0%, #ffecbf 100%);
          box-shadow: 0px 2px 10px 0px rgba(186, 49, 31, 1),
            0px 2px 0px 0px rgba(237, 179, 66, 1);
          border-radius: 21.5px;
          text-align: center;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #945e0e;
          line-height: 36px;
          margin-top: 24px;
          cursor: pointer;
          -webkit-animation: free_download 0.5s linear alternate infinite;
          animation: free_download 0.5s linear alternate infinite;
        }
      }
      & > div {
        &:nth-child(2),
        &:nth-child(3) {
          position: absolute;
          bottom: -20px;
        }
      }
      .left-boy {
        height: 149px;
        width: 87px;
        background: url(~@assets/img/share/img_boy.png) no-repeat center;
        background-size: 100%;
        left: 11px;
      }
      .right-girl {
        height: 143px;
        width: 106px;
        background: url(~@assets/img/share/img_girl.png) no-repeat center;
        background-size: 100%;
        right: 20px;
      }
    }
  }
  .footer {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 21px;
    left: 50%;
    margin-left: -54px;
    img {
      width: 108px;
      height: 25px;
    }
  }
}
@-webkit-keyframes free_download {
  0% {
    -webkit-transform: scale(0.9);
  }
  100% {
    -webkit-transform: scale(1);
  }
}
@keyframes free_download {
  0% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}
</style>
